module.exports = __webpack_public_path__ + "static/media/ic_map_location.f30c1ae4.svg";